module.exports = __webpack_public_path__ + "img/4.54c28c58.jpg";